import React from "react";
const WIDTH = 90;
const DEPTH = 40;
const HEIGHT = 30;

export default {
  name: "firesafety-fire-blanket",
  prototype: "items",

  info: {
    tag: ["furnishings", "metal"],
    title: "fire blanket",
    description: "fire-blanket",
    image: require("./fire-blanket.svg"),
    svgIcon: require("./fire-blanket.svg"),
  },
  properties: {
    scaleX: {
      label: "Width",
      type: "slider",
      min: 50,
      max: 250,
      defaultValue: 120,
    },
    scaleY: {
      label: "Depth",
      type: "slider",
      min: 50,
      max: 250,
      defaultValue: 120,
    },
  },

  render2D: function (element, layer, scene) {
    let angle = element.rotation + 90;

    return {
      element: (
        <g>
          <defs>
            <style>{`.fbcls1{fill:#d71214;}.fbcls2{fill:#fff;}`}</style>
          </defs>
          <g
            transform={`translate(-47, 55) scale(1, -1)`}
            id={`${element.type}-${element.id}`}
            data-name="corner shower"
          >
            <path
              class="fbcls1"
              d="M70,70.92H13.74V2.61H73.86V70.92ZM48.43,56.34a1.34,1.34,0,0,0,.07-.18c.16-.49.35-1,.48-1.45a20.36,20.36,0,0,0,.53-4.46,43.39,43.39,0,0,0-.12-4.56A17.3,17.3,0,0,0,49,42.82a16.14,16.14,0,0,0-3.83-7.08,18.75,18.75,0,0,0-4.92-3.89c-.1-.05-.19-.14-.34-.12q0,.35.06.66a13.48,13.48,0,0,1,0,2.46A12,12,0,0,1,39,38.22c-.55,1.29-1.2,2.53-1.86,3.76-1.45,2.73-2.88,5.47-4.19,8.27a15,15,0,0,0-1.32,4.44,13,13,0,0,0,.36,5.2,15,15,0,0,0,2.89,5.47,16.36,16.36,0,0,0,2.7,2.69.45.45,0,0,0,.29.15c0-.08,0-.14-.05-.2-.11-.44-.24-.88-.35-1.33A20.27,20.27,0,0,1,37,59.23a13.89,13.89,0,0,1,1.45-4.7,12.08,12.08,0,0,1,3.66-4.31l.33-.21a18.21,18.21,0,0,0,.21,4.5,20.46,20.46,0,0,0,1.2,4.26,19.35,19.35,0,0,0,2.09,4c.41-.2.81-.37,1.18-.57A27.67,27.67,0,0,0,50,60.36c.07-.06.15-.1.25-.17a4.66,4.66,0,0,1,0,.53c-.08.67-.15,1.33-.26,2-.29,1.76-.69,3.49-1.14,5.21a2.79,2.79,0,0,0-.07.34l.22-.17c.55-.52,1.11-1,1.62-1.56a21.6,21.6,0,0,0,4.5-7.14,14,14,0,0,0,.64-7.93,22.09,22.09,0,0,0-3-7.31c0-.07-.1-.13-.15-.2H52.5a18,18,0,0,1-.86,6.59A16.66,16.66,0,0,1,48.43,56.34ZM16.3,27.8l.18,0c1.45,0,2.9,0,4.36,0a4.17,4.17,0,0,0,1.35-.24,2,2,0,0,0,1.44-2.19,1.85,1.85,0,0,0-1-1.55,3.94,3.94,0,0,0-.36-.19l.16-.12a1.89,1.89,0,0,0,.79-2.05,1.87,1.87,0,0,0-1.28-1.4,3.62,3.62,0,0,0-1.26-.25H16.48l-.18,0Zm31.77,0v-8H46.24v4.78L46,24.35l-3.24-4c-.16-.19-.29-.45-.49-.55a2,2,0,0,0-.77,0h-.74c-.07.37-.05,7.78,0,8h1.81v-4.7a.81.81,0,0,1,.26.2L44,24.7l2.4,2.92c.08.09.13.21.28.2ZM42.24,7.24v8a7.67,7.67,0,0,0,1.86,0V13l.33,0c.35,0,.7,0,1,0a.5.5,0,0,1,.47.25c.4.6.81,1.19,1.22,1.78a.42.42,0,0,0,.39.21H49l.28,0c-.21-.32-.4-.59-.59-.87l-.59-.84c-.19-.27-.39-.54-.55-.8a9.63,9.63,0,0,0,.88-.68,2.83,2.83,0,0,0-.7-4.35,4.34,4.34,0,0,0-2.06-.46H42.52ZM52.89,24.7l.24.29c.72.88,1.45,1.76,2.17,2.65a.44.44,0,0,0,.37.19h1.71l.24,0-3.49-4.41,3.29-3.55-.35,0c-.47,0-.94,0-1.41,0a.65.65,0,0,0-.52.23c-1,1.09-2,2.16-3.08,3.24-.05.06-.12.11-.23.22V19.85a8,8,0,0,0-1.84,0V27.8h1.85v-.34c0-.48,0-1,0-1.44a.5.5,0,0,1,.08-.3C52.23,25.38,52.55,25.05,52.89,24.7Zm3.29-14.26h-3.7c0-.58,0-1.14,0-1.71h4.17a6.07,6.07,0,0,0,0-1.49h-6c-.06.36,0,7.77,0,8l.11,0h5.85l.15,0,0,0s0,0,0,0v-.69c0-.24,0-.48,0-.74H52.52a8,8,0,0,1,0-1.83h3.65Zm4.13,10.87H64.5c0-.51,0-1,0-1.48h-6v8c.31.06,6,.06,6.18,0a5,5,0,0,0,0-1.48H60.29c0-.62,0-1.2,0-1.81h1.86c.61,0,1.21,0,1.82,0V23H60.31Zm-20.39,6.5-3.57-8H34.48l-3.56,8h1.93l.7-1.66h3.7l.7,1.67ZM33.05,8.74h4.16V7.24h-6s0,0,0,.07a.71.71,0,0,0,0,.14v7.62a.5.5,0,0,0,0,.12l0,0,0,0c.58,0,1.18,0,1.8,0,0-1,0-1.93,0-2.91H36.7a5.29,5.29,0,0,0,0-1.51H33.05ZM69.64,27.8V21.33h2.51a4.69,4.69,0,0,0,0-1.5H65.21v1.51h2.55v5.4c0,.36,0,.71,0,1.06ZM26.9,26.3V19.83H25v8h5.85V26.3ZM40.3,15.23c.06-.35.05-7.76,0-8-.59,0-1.2,0-1.8,0v8Z"
              transform="translate(-13.74 -2.61)"
            />
            <path
              class="fbcls2"
              d="M48.43,56.34a16.66,16.66,0,0,0,3.21-5.79A18,18,0,0,0,52.5,44h.06c0,.07.11.13.15.2a22.09,22.09,0,0,1,3,7.31,14,14,0,0,1-.64,7.93,21.6,21.6,0,0,1-4.5,7.14c-.51.54-1.07,1-1.62,1.56l-.22.17a2.79,2.79,0,0,1,.07-.34c.45-1.72.85-3.45,1.14-5.21.11-.66.18-1.32.26-2a4.66,4.66,0,0,0,0-.53c-.1.07-.18.11-.25.17a27.67,27.67,0,0,1-2.87,1.81c-.37.2-.77.37-1.18.57a19.35,19.35,0,0,1-2.09-4,20.46,20.46,0,0,1-1.2-4.26,18.21,18.21,0,0,1-.21-4.5l-.33.21a12.08,12.08,0,0,0-3.66,4.31A13.89,13.89,0,0,0,37,59.23a20.27,20.27,0,0,0,.51,7.44c.11.45.24.89.35,1.33,0,.06,0,.12.05.2a.45.45,0,0,1-.29-.15,16.36,16.36,0,0,1-2.7-2.69A15,15,0,0,1,32,59.89a13,13,0,0,1-.36-5.2A15,15,0,0,1,33,50.25c1.31-2.8,2.74-5.54,4.19-8.27.66-1.23,1.31-2.47,1.86-3.76a12,12,0,0,0,.92-3.37,13.48,13.48,0,0,0,0-2.46q0-.31-.06-.66c.15,0,.24.07.34.12a18.75,18.75,0,0,1,4.92,3.89A16.14,16.14,0,0,1,49,42.82a17.3,17.3,0,0,1,.44,2.87,43.39,43.39,0,0,1,.12,4.56A20.36,20.36,0,0,1,49,54.71c-.13.49-.32,1-.48,1.45A1.34,1.34,0,0,1,48.43,56.34Z"
              transform="translate(-13.74 -2.61)"
            />
            <path
              class="fbcls2"
              d="M16.3,27.8v-8l.18,0h4.17a3.62,3.62,0,0,1,1.26.25,1.87,1.87,0,0,1,1.28,1.4,1.89,1.89,0,0,1-.79,2.05l-.16.12a3.94,3.94,0,0,1,.36.19,1.85,1.85,0,0,1,1,1.55,2,2,0,0,1-1.44,2.19,4.17,4.17,0,0,1-1.35.24c-1.46,0-2.91,0-4.36,0Zm1.87-3.34v1.92l.13,0h2.07a2.05,2.05,0,0,0,.88-.16.79.79,0,0,0,.49-.76.83.83,0,0,0-.44-.82,1.88,1.88,0,0,0-.87-.2H18.17Zm0-3.22c0,.61,0,1.21,0,1.82.77,0,1.5,0,2.22,0a1.41,1.41,0,0,0,.52-.15.84.84,0,0,0,0-1.49,2,2,0,0,0-.9-.19H18.38Z"
              transform="translate(-13.74 -2.61)"
            />
            <path
              class="fbcls2"
              d="M48.07,27.82h-1.4c-.15,0-.2-.11-.28-.2L44,24.7l-1.14-1.39a.81.81,0,0,0-.26-.2v4.7H40.78c-.06-.22-.08-7.63,0-8h.74a2,2,0,0,1,.77,0c.2.1.33.36.49.55l3.24,4,.23.26V19.83h1.83Z"
              transform="translate(-13.74 -2.61)"
            />
            <path
              class="fbcls2"
              d="M42.24,7.24l.28,0H45.7a4.34,4.34,0,0,1,2.06.46,2.83,2.83,0,0,1,.7,4.35,9.63,9.63,0,0,1-.88.68c.16.26.36.53.55.8l.59.84c.19.28.38.55.59.87l-.28,0H47.56a.42.42,0,0,1-.39-.21c-.41-.59-.82-1.18-1.22-1.78a.5.5,0,0,0-.47-.25c-.35,0-.7,0-1,0l-.33,0v2.15a7.67,7.67,0,0,1-1.86,0Zm1.88,4.29h1.5a3.91,3.91,0,0,0,.48,0,1.25,1.25,0,0,0,1-.71,1.34,1.34,0,0,0-.94-1.95l-.27,0-1.64,0a1,1,0,0,0-.17,0Z"
              transform="translate(-13.74 -2.61)"
            />
            <path
              class="fbcls2"
              d="M52.89,24.7c-.34.35-.66.68-1,1a.5.5,0,0,0-.08.3c0,.48,0,1,0,1.44v.34H50V19.86a8,8,0,0,1,1.84,0v3.64c.11-.11.18-.16.23-.22,1-1.08,2.06-2.15,3.08-3.24a.65.65,0,0,1,.52-.23c.47,0,.94,0,1.41,0l.35,0-3.29,3.55,3.49,4.41-.24,0H55.67a.44.44,0,0,1-.37-.19c-.72-.89-1.45-1.77-2.17-2.65Z"
              transform="translate(-13.74 -2.61)"
            />
            <path
              class="fbcls2"
              d="M56.18,10.44v1.47H52.53a8,8,0,0,0,0,1.83h4.31c0,.26,0,.5,0,.74v.69s0,0,0,0l0,0-.15,0H50.78l-.11,0c-.07-.22-.08-7.63,0-8h6a6.07,6.07,0,0,1,0,1.49H52.48c0,.57,0,1.13,0,1.71Z"
              transform="translate(-13.74 -2.61)"
            />
            <path
              class="fbcls2"
              d="M60.31,21.31V23H64v1.45c-.61,0-1.21,0-1.82,0H60.31c-.05.61,0,1.19,0,1.81h4.29a5,5,0,0,1,0,1.48c-.23.06-5.87.06-6.18,0v-8h6c0,.49,0,1,0,1.48Z"
              transform="translate(-13.74 -2.61)"
            />
            <path
              class="fbcls2"
              d="M39.92,27.81H38l-.7-1.67h-3.7l-.7,1.66H30.92l3.56-8h1.87Zm-5.76-3.15h2.48l-1.21-2.92h-.06Z"
              transform="translate(-13.74 -2.61)"
            />
            <path
              class="fbcls2"
              d="M33.05,8.74v2.08h3.62a5.29,5.29,0,0,1,0,1.51H33.05c0,1,0,1.93,0,2.91-.62,0-1.22,0-1.8,0l0,0,0,0a.5.5,0,0,1,0-.12V7.45a.71.71,0,0,1,0-.14s0,0,0-.07h6V8.73Z"
              transform="translate(-13.74 -2.61)"
            />
            <path
              class="fbcls2"
              d="M69.64,27.8H67.77c0-.35,0-.7,0-1.06v-5.4H65.21V19.83h6.93a4.69,4.69,0,0,1,0,1.5H69.64Z"
              transform="translate(-13.74 -2.61)"
            />
            <path
              class="fbcls2"
              d="M26.9,26.3h4v1.5H25v-8H26.9Z"
              transform="translate(-13.74 -2.61)"
            />
            <path
              class="fbcls2"
              d="M40.3,15.23H38.48v-8c.6,0,1.21,0,1.8,0C40.35,7.47,40.36,14.88,40.3,15.23Z"
              transform="translate(-13.74 -2.61)"
            />
            <path
              class="fbcls1"
              d="M18.17,24.46h2.26a1.88,1.88,0,0,1,.87.2.83.83,0,0,1,.44.82.79.79,0,0,1-.49.76,2.05,2.05,0,0,1-.88.16H18.3l-.13,0Z"
              transform="translate(-13.74 -2.61)"
            />
            <path
              class="fbcls1"
              d="M18.15,21.24l.23,0H20a2,2,0,0,1,.9.19.84.84,0,0,1,0,1.49,1.41,1.41,0,0,1-.52.15c-.72,0-1.45,0-2.22,0C18.14,22.45,18.15,21.85,18.15,21.24Z"
              transform="translate(-13.74 -2.61)"
            />
            <path
              class="fbcls1"
              d="M44.12,11.53V8.8a1,1,0,0,1,.17,0l1.64,0,.27,0a1.34,1.34,0,0,1,.94,1.95,1.25,1.25,0,0,1-1,.71,3.91,3.91,0,0,1-.48,0Z"
              transform="translate(-13.74 -2.61)"
            />
            <path
              class="fbcls1"
              d="M34.16,24.66l1.21-2.92h.06l1.21,2.92Z"
              transform="translate(-13.74 -2.61)"
            />
            <path
              class="fbcls1"
              d="M42.34,72.49"
              transform="translate(-13.74 -2.61)"
            />
            <rect x="11.07" y="68.31" width="10.6" height="13.75" />
            <rect x="35.52" y="68.31" width="10.6" height="13.75" />
          </g>
        </g>
      ),
      transform: {
        width: -WIDTH / 2,
        depth: -DEPTH / 2,
      },
    };
  },

  render3D: function (element, layer, scene) {},
};
